"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.018 7.475a.7.7 0 0 1 .7.7v5.351a.7.7 0 1 1-1.4 0v-5.35a.7.7 0 0 1 .7-.7m3.322-.001a.7.7 0 0 1 .7.7v5.351a.7.7 0 1 1-1.4 0v-5.35a.7.7 0 0 1 .7-.7m3.32-.001a.7.7 0 0 1 .7.7v5.351a.7.7 0 1 1-1.4 0v-5.35a.7.7 0 0 1 .7-.7m3.321-.001a.7.7 0 0 1 .7.7v5.351a.7.7 0 1 1-1.4 0v-5.35a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.537 4.614a1.3 1.3 0 0 0-1.075 0l-4.888 2.22a.3.3 0 0 0-.176.273v.068a.3.3 0 0 0 .3.3h10.604a.3.3 0 0 0 .3-.3v-.068a.3.3 0 0 0-.176-.273zM8.884 3.34a2.7 2.7 0 0 1 2.232 0l4.888 2.22a1.7 1.7 0 0 1 .998 1.547v.068a1.7 1.7 0 0 1-1.7 1.7H4.698a1.7 1.7 0 0 1-1.7-1.7v-.068a1.7 1.7 0 0 1 .997-1.548zM3.133 14.526a1.7 1.7 0 0 1 1.7-1.7h10.333a1.7 1.7 0 0 1 1.7 1.7v.676a1.7 1.7 0 0 1-1.7 1.7H4.833a1.7 1.7 0 0 1-1.7-1.7zm1.7-.3a.3.3 0 0 0-.3.3v.676a.3.3 0 0 0 .3.3h10.333a.3.3 0 0 0 .3-.3v-.676a.3.3 0 0 0-.3-.3z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BankIcon20.js.map